import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AutoStoriesOutlined, TrendingUpOutlined, VerifiedUserOutlined, CalendarMonthOutlined, LocationOnOutlined, NavigateNext, CleanHandsOutlined } from '@mui/icons-material';
import '../styles/SeoPages.css';
import '../styles/common.css';

const GoldGuidePage = () => {
    useEffect(() => {
        document.title = "Gold Guide by MAB Jewels | Expert Jewelry Insights & Live Rates";

        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute("content", "Explore the Gold Guide by MAB Jewels – Your trusted source for live gold rates in Rajasthan, purity guides, investment tips, and expert jewellery insights.");
        }
    }, []);

    const guideArticles = [
        {
            title: "Gold Rate in Rajasthan Today",
            description: "Live 22K & 24K prices, market trends, and city-wise breakdown for Jodhpur, Jaipur, and Udaipur.",
            link: "/gold-rate-rajasthan",
            icon: <TrendingUpOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Live Rates"
        },
        {
            title: "Gold Rate in Jodhpur Today",
            description: "Checking local Jodhpur bullion rates? Get accurate, real-time pricing from the city's trusted jeweller.",
            link: "/gold-rate-jodhpur",
            icon: <LocationOnOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Local Market"
        },
        {
            title: "How to Check Gold Purity (BIS Guide)",
            description: "Understand Hallmark, HUID, and the difference between 22K and 24K gold before you buy.",
            link: "/how-to-check-gold-purity-rajasthan", // Linking to transparency/BIS guide page
            icon: <VerifiedUserOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Education"
        },
        {
            title: "Best Time to Buy Gold in Rajasthan",
            description: "Discover seasonal trends, festive offers, and the smartest times to invest in gold jewellery.",
            link: "/best-time-to-buy-gold-rajasthan", // Deep linking to specific section if possible, or same page
            icon: <CalendarMonthOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Investment Tip"
        },
        {
            title: "Why MAB Jewels is Trusted in Jodhpur",
            description: "A legacy of trust, craftsmanship, and verified purity that makes us Rajasthan's preferred jeweller.",
            link: "/trusted-jewellery-store-jodhpur",
            icon: <AutoStoriesOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Brand Story"
        },
        {
            title: "BIS Hallmarking Guide",
            description: "Understand the 3 official signs of purity (BIS Logo, Purity Grade, HUID) to buy safely.",
            link: "/bis-hallmarking-guide",
            icon: <VerifiedUserOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Government Guide"
        },
        {
            title: "Jewellery Care Guide",
            description: "Expert tips on cleaning gold & silver, harsh chemicals to avoid, and safe storage methods.",
            link: "/jewellery-care-guide",
            icon: <CleanHandsOutlined sx={{ fontSize: 40, color: '#d4af37' }} />,
            tag: "Maintenance"
        }
    ];

    return (
        <div className="page-container seo-page">
            <div className="seo-content-wrapper" style={{ maxWidth: '1200px' }}>
                <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '16px', color: '#1a1a1a' }}>Gold Guide by MAB Jewels</h1>
                    <p style={{ fontSize: '1.2rem', color: '#666', maxWidth: '700px', margin: '0 auto' }}>
                        Your extensive knowledge hub for live gold rates, expert buying tips, and deep insights into the Rajasthan jewellery market.
                    </p>
                </div>

                <div className="gold-guide-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '30px',
                    padding: '20px 0'
                }}>
                    {guideArticles.map((article, index) => (
                        <Link to={article.link} key={index} style={{ textDecoration: 'none' }}>
                            <div className="guide-card" style={{
                                background: '#fff',
                                padding: '30px',
                                borderRadius: '16px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                                border: '1px solid #eee',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(212, 175, 55, 0.15)';
                                    e.currentTarget.style.borderColor = '#d4af37';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.05)';
                                    e.currentTarget.style.borderColor = '#eee';
                                }}
                            >
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px',
                                    background: '#fff9e6',
                                    color: '#d4af37',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '0.8rem',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    {article.tag}
                                </div>

                                <div style={{ marginBottom: '20px', background: '#fcfcfc', width: 'fit-content', padding: '15px', borderRadius: '50%' }}>
                                    {article.icon}
                                </div>
                                <h2 style={{ fontSize: '1.4rem', color: '#1a1a1a', marginBottom: '12px', lineHeight: '1.3' }}>
                                    {article.title}
                                </h2>
                                <p style={{ color: '#666', lineHeight: '1.6', flex: 1, marginBottom: '20px' }}>
                                    {article.description}
                                </p>
                                <div style={{ display: 'flex', alignItems: 'center', color: '#d4af37', fontWeight: '600', fontSize: '0.95rem' }}>
                                    Read Guide <NavigateNext sx={{ fontSize: 20, ml: 0.5 }} />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div style={{ marginTop: '60px', textAlign: 'center', background: '#f9f9f9', padding: '40px', borderRadius: '16px' }}>
                    <h3 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>Looking for certified gold jewellery?</h3>
                    <p style={{ color: '#666', marginBottom: '24px' }}>Explore the finest BIS-hallmarked collection in Jodhpur.</p>
                    <Link to="/jewellery" style={{
                        background: '#1a1a1a',
                        color: '#d4af37',
                        padding: '12px 30px',
                        borderRadius: '30px',
                        textDecoration: 'none',
                        fontWeight: '600',
                        display: 'inline-block'
                    }}>
                        View Collection
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default GoldGuidePage;
